<span
  class="locked"
  *ngIf="locked"
  rivTooltip="You don't have permission to view this item"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
  <riv-icon [name]="'Lock'" [size]="16"></riv-icon>
</span>
<ng-container *ngIf="!locked">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>
<ng-template #content><ng-content></ng-content></ng-template>
